export class TrendItem {
    public readonly year: number;
    public readonly amount: number;
    constructor(year: number, amount: number){
        this.year = year
        this.amount = amount
    }
}

export function buildTrendItem(entry: any, _index: number) {
    //const key = Object.keys(entry)[0];
    const key =entry.year;
    const value =entry.count;
    return new TrendItem(key,value);
}

export function buildTrendItemExp(entry: any, _index: number) {
    //const key = Object.keys(entry)[0];
    const key =entry.year;
    const value =entry.expenditure;
    return new TrendItem(key,value);
}

export function sortTrend(item1: TrendItem, item2: TrendItem) {
    return item1.year - item2.year;
}



// WEBPACK FOOTER //
// ./src/models/TrendItem.ts